// app/javascript/test.js

$(function() {
  $('#test').css('color','#ff0000')
  $('.hoge').css('color','#0000ff')
});